import { useNavigate, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import eceaLogo from "../assets/logo/ecea-logo.png";

export default function NavBar() {

const navigate = useNavigate();
const location = useLocation();

const [scrolled, setScrolled] = useState(false);
const [active, setActive] = useState("home");

/* navbar shrink on scroll */
useEffect(() => {
const handleScroll = () => setScrolled(window.scrollY > 60);
window.addEventListener("scroll", handleScroll);
return () => window.removeEventListener("scroll", handleScroll);
}, []);

/* detect route change */
useEffect(() => {


const { pathname, hash } = location;

if (pathname === "/events") setActive("events");
else if (pathname === "/workshop") setActive("workshop");
else if (hash === "#team") setActive("team");
else if (hash === "#contact") setActive("contact");
else setActive("home");


}, [location]);

const linkClass = (name) =>
"px-6 py-2 rounded-full text-base font-medium transition " +
(active === name
? "bg-white/30 text-white"
: "text-white/70 hover:text-white hover:bg-white/20");

const scrollTo = (id) => {


const scroll = () => {

  const el = document.getElementById(id);

  if (!el) return;

  const offset = 0;   // push slightly lower so previous section disappears
  const top = el.getBoundingClientRect().top + window.pageYOffset - offset;

  window.scrollTo({
    top,
    behavior: "smooth"
  });

  setActive(id);

};

if (location.pathname !== "/") {
  navigate("/#" + id);
  setTimeout(scroll, 200);
} else {
  window.history.replaceState(null, "", "/#" + id);
  scroll();
}


};

const goHome = () => {


navigate("/");

window.scrollTo({
  top: 0,
  behavior: "smooth"
});

setActive("home");


};

return (
<>
{/* Logo */} <div className="absolute top-6 left-10 z-40 cursor-pointer"> <div className="p-2 transition duration-300"> <img
         src={eceaLogo}
         alt="ECEA"
         onClick={goHome}
         className="h-24 transition-transform duration-300 hover:scale-110"
       /> </div> </div>


  {/* Navbar */}
  <nav className="fixed top-6 left-1/2 -translate-x-1/2 z-50">

    <div
      className={`flex items-center rounded-full
      bg-[#0b1220]/80 backdrop-blur-2xl border border-white/20 shadow-xl
      transition-all duration-300
      ${scrolled ? "px-10 py-2" : "px-14 py-3"}`}
    >

      <button onClick={goHome} className={linkClass("home")}>
        Home
      </button>

      <button
        onClick={() => {
          navigate("/events");
          window.scrollTo({ top: 0, behavior: "smooth" });
          setActive("events");
        }}
        className={linkClass("events")}
      >
        Events
      </button>

      <button
        onClick={() => {
          navigate("/workshop");
          window.scrollTo({ top: 0, behavior: "smooth" });
          setActive("workshop");
        }}
        className={linkClass("workshop")}
      >
        Workshop
      </button>

      <button
        onClick={() => scrollTo("team")}
        className={linkClass("team")}
      >
        Teams
      </button>

      <button
        onClick={() => scrollTo("contact")}
        className={linkClass("contact")}
      >
        Contact
      </button>

    </div>

  </nav>
</>

);
}

